// @ts-ignore
/* eslint-disable */
import { request } from 'umi';

/** 发送验证码 POST /api/login/captcha */
export async function getFakeCaptcha(
  params: {
    // query
    /** 手机号 */
    phone?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.FakeCaptcha>('/api/login/captcha', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** core--通用身份验证接口--[B端]通过用户id发送短信验证码
 * @method GET
 * @url /core/auth/generic/client/code/user
 * @param {String} mobile   *新手机号
 */
export async function getCaptchaByPhone(params: { mobile: string,prefix?:string,tenantId?:string }) {
  return request('/core/customer/account/client/code/user', { params })
}
/** 登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/core/user/account/logout', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: { password: string | number[]; domain: string; account: string | undefined; platform: number | React.ReactText }, options?: { [p: string]: any }) {
  return request<API.ResponseData<API.LoginResult>>('/core/user/account/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
/** 登录接口 POST /api/login/account */
export async function ccrcLogin(body: { password: string | number[]; domain: string; account: string | undefined; platform: number | React.ReactText }, options?: { [p: string]: any }) {
  return request<API.LoginResult>('/manage/oauth/administrator/account/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
/** 双重登录获取用户名密码 */
export async function getLoginPhone(body: { password: string | number[]; domain: string; account: string | undefined; platform: number | React.ReactText }, options?: { [p: string]: any }) {
  return request<API.ResponseData<API.LoginResult>>('/core/user/account/getLoginPhone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
/**  */
export async function loginByPhoneAndCode(body: { phone: string | number; code:string,codeId:string, domain: string; account: string | undefined; platform: number | React.ReactText }, options?: { [p: string]: any }) {
  return request<API.ResponseData<API.LoginResult>>('/core/user/account/loginByPhoneAndCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
